<template>
  <el-dialog @closed="closeDialog" :title="title" append-to-body :close-on-click-modal="false" :visible.sync="visible" width="976px">
    <el-form :model="detail" :rules="dataRule" ref="dataForm" label-width="110px">
      <el-row :gutter="40">
        <el-col :span="12">
          <el-row :gutter="10" style="margin: 0;">
            <el-col :span="18">
              <el-form-item label="企业名称" prop="deptName">
                <el-input style="width: 100%;" v-model="detail.deptName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button style="padding: 12px 8px;" type="primary" @click="checkCompany">对接企查查</el-button>
            </el-col>
          </el-row>
          <el-form-item label="开户行" prop="bank">
            <el-input v-model="detail.bank"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="纳税人识别号" prop="ratepayCode">
            <el-input v-model="detail.ratepayCode"></el-input>
          </el-form-item>
          <el-form-item label="开户行账号" prop="bankAccount">
            <el-input v-model="detail.bankAccount"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="注册地址" prop="addr">
            <el-input v-model="detail.addr"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="formOK">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { isCharacter } from "@/utils/validate";
export default {
  data() {
    var validateRatepayCode = (rule, value, callback) => {
      if (!isCharacter(value)) {
        callback(new Error(`${rule.field=="ratepayCode"?"纳税识别码":"开户行账号"}只能含有数字或英文`));
      } else {
        callback();
      }
    };
    return {
      title:"",
      visible: false,
      detail: {},
      dataRule: {
        deptName: [{ required: true, message: "企业信息不能为空", trigger: "blur" }],
        ratepayCode: [{ required: true, message: "纳税人识别号不能为空", trigger: "blur" },
        { validator: validateRatepayCode, trigger: "blur" }],
        bank: [{ required: true, message: "开户行不能为空", trigger: "blur" }],
        addr: [{ required: true, message: "注册地址不能为空", trigger: "blur" }],
        bankAccount: [{ required: true, message: "开户行账号不能为空", trigger: "blur" },
        { validator: validateRatepayCode, trigger: "blur" }]
      }
    };
  },
  methods: {
    checkCompany(){
      this.$message({
        message: "功能保留，暂不对接",
        type: "info"
      });
    },
    formOK() {
      this.$refs.dataForm.validate((valid) => {
					if (valid) {
            delete this.detail.createTime;
            delete this.detail.creatorName;
            delete this.detail.validSt;
            this.$http.post(this.detail.id ? this.$api.shiroApi.tickUpdate :this.$api.shiroApi.tickAdd, this.detail).then(({ data }) => {
              this.$message({
                message: data.msg,
                type: "success"
              });
              this.visible = false;
              this.$emit("fresh");
            });
          }
      })
    },
    closeDialog() {
      this.$refs.dataForm.resetFields();
    },
    init(obj) {
      this.visible = true;
      this.title = `${obj.id ? "修改" : "新增"}开票信息`;
      this.detail = obj;
    }
  },
};
</script>
<style lang="scss" scoped>

::v-deep .el-dialog__body {
  padding-top: 0;
  padding-bottom: 24px;
}

.el-form {
  width: 843px;
  margin: 0 auto;
  margin-top: 32px;
}

::v-deep .el-dialog__footer {
  padding-top: 21px;
}

.el-dialog__footer .el-button {
  border-radius: 20px;
  width: 80px;
  line-height: 38px;
  font-size: 14px;
}
</style>
